import { requestUS } from './usQuotes'
import { isMarketOpen } from './marketRefresh'

export function usMinutes(rows) {
  let previous = 0, amount = 0
  return (rows || []).map(line => {
    const [time, price, volume] = line.split(' ').map(Number)
    const vol = Math.max(0, volume - previous)
    previous = volume; amount += vol * price
    return { time, price, open: price, high: price, low: price, vol, avprice: volume ? amount / volume : price }
  }).filter(row => Number.isFinite(row.time) && row.price > 0 && Number.isFinite(row.vol))
}

// Only handle chart requests implemented here, never fall back to HQChart demo data.
export function usChartFilter(code, symbol, onError = () => {}, requester = requestUS, onQuote = () => {}, managed = false) {
  const failures = new Map()
  const loaded = new Set()
  const filter = async (data, callback) => {
    data.PreventDefault = true
    if (data.Self.IsDestroy || document.hidden) return
    const minute = data.Name === 'MinuteChartContainer::RequestMinuteData'
    const days = data.Name === 'MinuteChartContainer::RequestHistoryMinuteData'
    const history = data.Name === 'KLineChartContainer::RequestHistoryData'
    const realtime = data.Name === 'KLineChartContainer::RequestRealtimeData'
    if (!minute && !days && !history && !realtime) { callback({ code: 0, data: [] }); return }
    const key = `${data.Name}:${data.Self.Period || 0}`
    const initial = !loaded.has(key)
    if ((realtime || (!initial && minute)) && !isMarketOpen('us')) return
    try {
      const result = await requester(minute ? 'us-minute' : days ? 'us-days' : 'us-kline', { code, period: ['day', 'week', 'month'][data.Self.Period || 0] })
      if (data.Self.IsDestroy) return
      const body = typeof result === 'string' ? JSON.parse(result.slice(result.indexOf('=') + 1).replace(/;\s*$/, '')) : result
      const stock = body && body.data && body.data[code]
      if (!stock) throw new Error('No US chart data')
      if (minute) {
        const points = usMinutes(stock.data && stock.data.data)
        if (!points.length) throw new Error('No minute points')
        callback({ code: 0, stock: [{ name: symbol, symbol, date: Number(stock.data.date), yclose: Number(stock.qt && stock.qt[code] && stock.qt[code][4]), minute: points }] })
      } else if (days) {
        const rows = (stock.data || []).map(day => ({ date: Number(day.date), yclose: Number(day.prec), minute: usMinutes(day.data).map(row => [row.time, row.price, row.open, row.high, row.low, row.vol, null, row.avprice]) }))
        if (!rows.length) throw new Error('No days')
        callback({ code: 0, name: symbol, symbol, data: rows })
      } else {
        const period = ['day', 'week', 'month'][data.Self.Period || 0]
        let previous = null
        const rows = (stock[period] || []).map(row => {
          const close = Number(row[2]), result = [Number(row[0].replace(/-/g, '')), previous, Number(row[1]), Number(row[3]), Number(row[4]), close, Number(row[5]), null]
          previous = close; return result
        })
        if (!rows.length) throw new Error('No K lines')
        // HQChart selects its array-based realtime decoder with the case-sensitive Ver field.
        callback(realtime ? { code: 0, Ver: 3, stock: [{ name: symbol, symbol, data: rows.slice(-1) }] } : { code: 0, name: symbol, symbol, data: rows })
      }
      if (stock.qt) onQuote(stock.qt, code)
      loaded.add(key)
      onError('')
      failures.delete(data.Name)
    } catch (error) {
      if (data.Self.IsDestroy || error.isAuthExpired) return
      onError('美股图表暂时无法加载，请切换周期重试')
      callback(minute ? { code: 0, stock: [] } : { code: 0, data: [], symbol })
      const count = (failures.get(data.Name) || 0) + 1
      failures.set(data.Name, count)
      if (!managed && count <= 2) setTimeout(() => { if (!data.Self.IsDestroy && !document.hidden) filter(data, callback) }, 2000)
    }
  }
  return filter
}
